import React, { useRef, CSSProperties } from "react";
import classNames from "classnames";
import LoyaltyCardRank, {
  type LoyaltyCardRankProps,
} from "components/molecules/LoyaltyCardRank";
import { useBreakpoint } from "hooks/useBreakpoint";
import { LoyaltyCardRankContainer } from "containers/molecules/LoyaltyCardRankContainer";
import { LoyaltyButtonSlider } from "components/atoms/LoyaltyButtonSlider";
import LoyaltyNavButton from "components/atoms/LoyaltyNavButton";
import { useDragSlider } from "./hooks";
import url from "../../../url";
import "./styles.sass";

type LoyaltyCarouselProps = {
  rank: string;
  cards: LoyaltyCardRankProps[];
  defaultIndex?: number;
  rankImage?: string;
};

export const LoyaltyCarousel = ({
  cards,
  rank,
  defaultIndex = 0,
  rankImage,
}: LoyaltyCarouselProps) => {
  const {
    activeCard,
    refContainer,
    refItems,
    isDragging,
    disabledPrev,
    disabledNext,
    onHandlePrev,
    onHandleNext,
    handleStopDragging,
    handleMouseDown,
    handleMouseMove,
    handleTouchStart,
    handleTouchMove,
  } = useDragSlider({ len: cards.length, defaultIndex });
  const { isDesktop } = useBreakpoint();
  const refStyle = useRef<CSSProperties>({ opacity: 0 });
  const bonusPath = url.routes.profile.bonus();
  const ranksPath = url.routes.profile.loyaltyProgramRanks();

  return (
    <div
      className="LoyaltyCarousel"
      ref={refContainer}
      onMouseLeave={handleStopDragging}
      onTouchEnd={handleStopDragging}
      id="loyalty-user-carousel"
    >
      <div className="LoyaltyCarousel__links">
        <LoyaltyNavButton
          path={ranksPath}
          title="loyalty.your.rank"
          btnText={rank}
          className="LoyaltyCarousel__linksItem"
        >
          <img src={rankImage} alt="" className="LoyaltyCarousel__rankImage" />
        </LoyaltyNavButton>
        <LoyaltyNavButton
          path={bonusPath}
          title="loyalty.rank.title-rewards"
          btnText="loyalty.btn.myBonuses"
          className="LoyaltyCarousel__linksItem"
        />
      </div>
      <div
        ref={refItems}
        className={classNames(
          "LoyaltyCarousel__inner",
          isDragging && "LoyaltyCarousel__inner_isDragging",
        )}
        onMouseDown={handleMouseDown}
        onMouseUp={handleStopDragging}
        onMouseMove={handleMouseMove}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleStopDragging}
        onTouchMove={handleTouchMove}
      >
        <LoyaltyButtonSlider
          disabled={disabledPrev}
          handleClick={onHandlePrev}
          className="LoyaltyCarousel__prevButton"
        />
        <LoyaltyCardRank
          rankExperience={0}
          prevRankExperience={0}
          nameRank=""
          userExperience={0}
          styles={refStyle.current}
        />
        <LoyaltyCardRank
          rankExperience={0}
          prevRankExperience={0}
          nameRank=""
          userExperience={0}
          styles={refStyle.current}
        />
        {!isDesktop && (
          <>
            <LoyaltyCardRank
              rankExperience={0}
              prevRankExperience={0}
              nameRank=""
              userExperience={0}
              styles={refStyle.current}
            />
            <LoyaltyCardRank
              rankExperience={0}
              prevRankExperience={0}
              nameRank=""
              userExperience={0}
              styles={refStyle.current}
            />
          </>
        )}
        {cards.map((card, index, arr) => (
          <LoyaltyCardRankContainer
            {...card}
            key={
              card?.level ? `${card.nameRank} - ${card.level}` : card.nameRank
            }
            isActive={index === activeCard}
            isFinal={index === arr.length - 1}
            canLoadInfo={
              index === activeCard ||
              index - 1 === activeCard ||
              index + 1 === activeCard ||
              index + 2 === activeCard ||
              index - 2 === activeCard
            }
          />
        ))}
        <LoyaltyCardRank
          rankExperience={0}
          prevRankExperience={0}
          nameRank=""
          userExperience={0}
          styles={refStyle.current}
        />
        <LoyaltyCardRank
          rankExperience={0}
          prevRankExperience={0}
          nameRank=""
          userExperience={0}
          styles={refStyle.current}
        />
        {!isDesktop && (
          <>
            <LoyaltyCardRank
              rankExperience={0}
              prevRankExperience={0}
              nameRank=""
              userExperience={0}
              styles={refStyle.current}
            />
            <LoyaltyCardRank
              rankExperience={0}
              prevRankExperience={0}
              nameRank=""
              userExperience={0}
              styles={refStyle.current}
            />
          </>
        )}
        <LoyaltyButtonSlider
          disabled={disabledNext}
          handleClick={onHandleNext}
          revert
          className="LoyaltyCarousel__nextButton"
        />
      </div>
    </div>
  );
};
